<template src="./unitTypeList.template.html"></template>
<script>
    import $ from "jquery";

    export default {
        // options
        name: "UnitTypeList",
        props: [],
        data() {
            return {
                statusList: [],
                propertyList: [],
                unitTypeId: -1,
                statusId: 1,
                propertyId: -1,
                headerColumnList: {
                    PROPERTYNAME: {
                        Label: "PROPERTY NAME",
                        IsChecked: true,
                        ColumnName: "Property",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    UNITTYPE: {
                        Label: "UNIT TYPE NAME",
                        IsChecked: true,
                        ColumnName: "UnitTypeName",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    NICKNAME: {
                        Label: "UNIT TYPE NICKNAME",
                        IsChecked: true,
                        ColumnName: "UnitTypeNickname",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    // UNITCLASS: { Label: "UNIT CLASS", IsChecked: true, ColumnName: "UNIT CLASS" },
                    // EndDate: { Label: "", IsChecked: true, ColumnName: "EndDate" },
                    MAXOCCUPANCY: {
                        Label: "MAX OCCUPANCY",
                        IsChecked: true,
                        ColumnName: "MaxPersons",
                        columnClass: "numeriColumn",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    UNITTYPERANK: {
                        Label: "UNIT TYPE RANK",
                        IsChecked: true,
                        ColumnName: "UnitTypeRank",
                        columnClass: "numeriColumn",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    // SourceName: { Label: "Source Name", IsChecked: true,  ColumnName: "SourceName"},
                    STATUS: {
                        Label: "STATUS",
                        IsChecked: true,
                        ColumnName: "StatusName",
                        columnClass: "numeriColumn",
                        isSortLoading: false,
                        isAscOrDesc: null
                    }
                },
                loading: false,
                unitTypeDetailList: [],
                sortOrder: null,
                sortBy: null,
            };
        },

        methods: {
            getPropertyMetaData: function () {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertiesBySearchText",
                    params: {},
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("GetPropertiesBySearchText==>", response);
                            vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
                            vm.statusList.splice(0, vm.statusList.length, ...response.statusList);
                        }
                    }
                });
            },
            getUnitTypeDetailList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_UnitTypeList",
                    params: {
                        sortBy: vm.sortBy,
                        sortOrder: vm.sortOrder,
                        propertyId: vm.propertyId,
                        statusId: vm.statusId,
                        searchText: null,
                        FromSetup: true
                    },
                    callback: function (err, response) {
                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In getting Unit Type list"
                            });
                            return;
                        }
                        if (response) {
                            console.log("Get_UnitTypeList==>", response);
                            if (response[1]) {
                                vm.unitTypeDetailList.splice(0, vm.unitTypeDetailList.length, ...response[1]);
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Unit Type list rendered successfully"
                                });
                            }
                        }
                    }
                });
            },
            unitTypeDetail(unitTypeId, unitListPopertyId) {
                let vm = this;
                let propertyId = -1;
                if (unitTypeId == -1) {
                    propertyId = vm.propertyId
                } else {
                    propertyId = unitListPopertyId
                }
                vm.$router.push("/unitTypeDetail/" + unitTypeId + "/" + propertyId);
            },
            ascSort(column, sortOrder) {
                let vm = this;
                vm.sortBy = column.ColumnName;
                vm.sortOrder = sortOrder;
                for (var headerColumn of vm.headerColumnList) {
                    if (headerColumn) {
                        if (column.ColumnName.toString() === headerColumn.ColumnName) {
                            console.log("obj.ColumnName", headerColumn.ColumnName);
                            headerColumn.isSortLoading = true;
                            headerColumn.isAscOrDesc = sortOrder.toString();
                        }
                    }
                }
                vm.getUnitTypeDetailList();
            }
        },

        computed: {},

        watch: {},
        created() { },
        mounted() {
            let vm = this;
            vm.getPropertyMetaData();
            vm.getUnitTypeDetailList();
        }
    };
</script>